module.exports = __webpack_public_path__ + "static/media/carsphoto.280ba0a9.jpeg";